import React, { useState } from 'react';
import './Support.css';

function Support() {
  const [openFaq, setOpenFaq] = useState(null);

  const faqs = [
    {
      question: "How do I play Wordalanche?",
      answer: "Tap on letters to select them and build words. Once you've formed a valid word, hit Submit to score points. The longer your word, the more points you earn! Watch out - letters keep falling from above, so don't let them stack too high!"
    },
    {
      question: "What is a Skillshot?",
      answer: "A Skillshot is when you submit a word that matches the target word length shown at the top of the screen. Landing a Skillshot gives you a 50% score bonus! Chain multiple Skillshots together for even bigger rewards."
    },
    {
      question: "How do power-ups work?",
      answer: "You have four power-ups: Refresh (replaces all letters with new ones), Clear Row (removes an entire row), Clear Column (removes an entire column), and Freeze (temporarily pauses falling letters). Use them strategically to stay in the game longer!"
    },
    {
      question: "What are the special tiles?",
      answer: "Ice blocks require multiple taps to break. Rainbow letters act as wildcards and can be any letter you need. Multiplier tiles boost your word score. Bomb tiles clear surrounding letters when used in a word."
    },
    {
      question: "How do I earn gems?",
      answer: "Gems are earned by completing achievements, maintaining daily streaks, and reaching score milestones. Use gems to purchase power-ups and customize your game experience."
    },
    {
      question: "What happens when letters reach the top?",
      answer: "If letters stack all the way to the danger line at the top of the grid, the game ends. Keep clearing words to push the stack back down and survive as long as possible!"
    },
    {
      question: "How do daily streaks work?",
      answer: "Play at least one game every day to build your streak. The longer your streak, the bigger your daily bonus rewards! Miss a day and your streak resets to zero."
    },
    {
      question: "Is the game free to play?",
      answer: "Yes! Wordalanche is free to download and play. Optional in-app purchases are available for additional gems and power-ups, but they're not required to enjoy the full game."
    }
  ];

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <div className="support-page">
      <section className="support-hero">
        <div className="support-bg-elements">
          <div className="support-glow support-glow-1"></div>
          <div className="support-glow support-glow-2"></div>
        </div>
        <div className="container">
          <h1>Support Center</h1>
          <p>Got questions? We've got answers. Find help below or reach out directly.</p>
        </div>
      </section>

      <section className="section faq-section">
        <div className="container">
          <div className="section-title">
            <h2>Frequently Asked Questions</h2>
            <p>Everything you need to know about playing Wordalanche</p>
          </div>

          <div className="faq-list">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={`faq-item ${openFaq === index ? 'open' : ''}`}
                onClick={() => toggleFaq(index)}
              >
                <div className="faq-question">
                  <h3>{faq.question}</h3>
                  <span className="faq-toggle">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M6 9l6 6 6-6"/>
                    </svg>
                  </span>
                </div>
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section contact-section">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-card card">
              <div className="contact-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
              </div>
              <h3>Email Support</h3>
              <p>Have a specific issue? Send us an email and we'll get back to you within 24-48 hours.</p>
              <a href="mailto:support@playbestentertainment.com" className="btn btn-secondary">
                support@playbestentertainment.com
              </a>
            </div>

            <div className="contact-card card">
              <div className="contact-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
                </svg>
              </div>
              <h3>Social Media</h3>
              <p>Follow us for tips, updates, and to connect with other Wordalanche players!</p>
              <div className="social-links">
                <a href="https://twitter.com/wordalanche" target="_blank" rel="noopener noreferrer" className="social-btn">
                  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
                </a>
                <a href="https://instagram.com/wordalanche" target="_blank" rel="noopener noreferrer" className="social-btn">
                  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
                </a>
              </div>
            </div>

            <div className="contact-card card">
              <div className="contact-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                  <line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
              </div>
              <h3>Bug Reports</h3>
              <p>Found a bug? Help us improve by reporting issues directly via email.</p>
              <a href="mailto:bugs@playbestentertainment.com" className="btn btn-secondary">
                Report a Bug
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="section tips-section">
        <div className="container">
          <div className="section-title">
            <h2>Pro Tips</h2>
            <p>Level up your Wordalanche game with these strategies</p>
          </div>

          <div className="tips-grid">
            <div className="tip-card">
              <span className="tip-number">01</span>
              <h4>Prioritize Longer Words</h4>
              <p>Longer words clear more letters and score exponentially more points. Aim for 5+ letter words when possible.</p>
            </div>
            <div className="tip-card">
              <span className="tip-number">02</span>
              <h4>Watch the Skillshot Target</h4>
              <p>The target word length changes periodically. Keep an eye on it and try to match it for bonus points.</p>
            </div>
            <div className="tip-card">
              <span className="tip-number">03</span>
              <h4>Save Power-Ups for Emergencies</h4>
              <p>Don't waste power-ups early. Save Freeze and Clear Row for when the stack gets dangerously high.</p>
            </div>
            <div className="tip-card">
              <span className="tip-number">04</span>
              <h4>Use Rainbow Letters Wisely</h4>
              <p>Rainbow letters are wildcards. Save them for longer words where you're missing just one letter.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Support;
